export const AUTRE = 'Autre';
export const FACTURE = 'Facture';
export const AVOIR = 'Avoir';
export const ACOMPTE = 'Acompte';
export const REGLEMENT = 'Reglement';
export const ESCOMPTE = 'Escompte';
export const GESTION_COURANTE = 'GestionCourante';
export const CHARGE = 'Charge';
export const PAIEMENT = 'Paiement';
export const AVOIR_DE_CHARGE = 'AvoirDeCharge';
export const OD = 'Od';

export const LISTE_TYPE_PIECE = [
  { code: AUTRE, libelle: 'mouvementClientPiece.type.autre' },
  { code: FACTURE, libelle: 'mouvementClientPiece.type.facture' },
  { code: AVOIR, libelle: 'mouvementClientPiece.type.avoir' },
  { code: ACOMPTE, libelle: 'mouvementClientPiece.type.acompte' },
  { code: REGLEMENT, libelle: 'mouvementClientPiece.type.reglement' },
  { code: ESCOMPTE, libelle: 'mouvementClientPiece.type.escompte' },
  { code: GESTION_COURANTE, libelle: 'mouvementClientPiece.type.gestionCourante' },
  { code: CHARGE, libelle: 'mouvementClientPiece.type.charge' },
  { code: PAIEMENT, libelle: 'mouvementClientPiece.type.paiement' },
  { code: OD, libelle: 'mouvementClientPiece.type.od' },
  { code: AVOIR_DE_CHARGE, libelle: 'mouvementClientPiece.type.avoirDeCharge' },
];

export const LISTE_TYPE_PIECE_VENTE = [
  { code: AUTRE, libelle: 'mouvementClientPiece.type.autre' },
  { code: FACTURE, libelle: 'mouvementClientPiece.type.facture' },
  { code: AVOIR, libelle: 'mouvementClientPiece.type.avoir' },
  { code: ACOMPTE, libelle: 'mouvementClientPiece.type.acompte' },
  { code: REGLEMENT, libelle: 'mouvementClientPiece.type.reglement' },
  { code: ESCOMPTE, libelle: 'mouvementClientPiece.type.escompte' },
  { code: GESTION_COURANTE, libelle: 'mouvementClientPiece.type.gestionCourante' },
  { code: OD, libelle: 'mouvementClientPiece.type.od' },
];

export const LISTE_TYPE_PIECE_ACHAT = [
  { code: AUTRE, libelle: 'mouvementClientPiece.type.autre' },
  { code: CHARGE, libelle: 'mouvementClientPiece.type.charge' },
  { code: PAIEMENT, libelle: 'mouvementClientPiece.type.paiement' },
  { code: OD, libelle: 'mouvementClientPiece.type.od' },
];

export const ECRANS_JOURNAL_MOUVEMENTS_EXPORT_EXCEL = 'journalmouvements';
export const ECRANS_JOURNAL_REGLEMENTS_TYPE_EXPORT_EXCEL = 'reglements';
export const ECRANS_JOURNAL_PAIEMENTS_TYPE_EXPORT_EXCEL = 'paiements';
